<template>
  <Modal :is-open="isOpen" :footer-class="loading ? 'hidden' : ''" @modal:confirm="generarPago" @modal:cancel="onCancel"
    class="z-10 flex items-center justify-center" container-class="max-h-full rounded-lg">
    <Cargando v-if="loading" mensaje="Guardando datos..." class="px-4 py-2 md:p-6" />
    <div v-else class="overflow-y-auto px-4 py-2 sm:flex sm:items-start md:p-6">
      <div
        class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-yellow-100 sm:mx-0 sm:h-10 sm:w-10">
        <SolidExclamationIcon class="h-6 w-6 text-yellow-500" />
      </div>

      <div class="mt-3 space-y-4 text-center sm:ml-4 sm:mt-0 sm:text-left">
        <h3 class="text-lg font-medium leading-6 text-gray-900" id="modal-title">
          <span v-if="medioPago"> Se generará un comprobante con los siguientes datos: </span>
          <span v-else>
            Se generará un comprobante con los siguientes datos, y quedará disponible en el sistema
            para su posterior pago:
          </span>
        </h3>

        <div class="my-2 rounded-md border border-gray-200 p-2">
          <div>
            <span class="font-medium">Tipo de comprobante: </span>
            <span>{{ formulario.nombre }}</span>
          </div>
          <div v-if="medioPago">
            <span class="font-medium">Medio de pago: </span>
            <span>{{ medioPago.descripcion }}</span>
          </div>
          <div v-if="datosComprobante.formulario.nombre">
            <span class="font-medium">Nombre: </span>
            <span>{{ datosComprobante.formulario.nombre }}</span>
          </div>
          <div v-if="datosComprobante.formulario.apellido">
            <span class="font-medium">Apellido: </span>
            <span>{{ datosComprobante.formulario.apellido }}</span>
          </div>
          <div v-if="datosComprobante.formulario.cuitCuil">
            <span class="font-medium">CUIT/CUIL: </span>
            <span>{{ datosComprobante.formulario.cuitCuil | cuit }}</span>
          </div>
          <div v-if="datosComprobante.formulario.email">
            <span class="font-medium">E-mail: </span>
            <span>{{ datosComprobante.formulario.email }}</span>
          </div>
          <div v-if="datosComprobante.formulario.telefono">
            <span class="font-medium">Teléfono: </span>
            <span>{{ datosComprobante.formulario.telefono | cuit }}</span>
          </div>
          <div v-if="datosComprobante.formulario.organismo">
            <span class="font-medium">Organismo: </span>
            <span>{{ datosComprobante.formulario.organismo.descripcion }}</span>
          </div>
          <div v-if="datosComprobante.formulario.matricula">
            <span class="font-medium">Matrícula: </span>
            <span>{{ datosComprobante.formulario.matricula }}</span>
          </div>
          <div v-if="datosComprobante.formulario.tramite">
            <span class="font-medium">Trámite: </span>
            <span>{{ datosComprobante.formulario.tramite.descripcion }}</span>
          </div>
          <div v-if="datosComprobante.formulario.importe">
            <span class="font-medium">Importe: </span>
            <span>{{ datosComprobante.formulario.importe | currency }}</span>
          </div>
          <div v-if="datosComprobante.formulario.sede">
            <span class="font-medium">Delegación: </span>
            <span>{{ datosComprobante.formulario.sede.descripcion }}</span>
          </div>
          <div v-if="datosComprobante.formulario.destinatario">
            <span class="font-medium">Quién abonará: </span>
            <span v-if="datosComprobante.formulario.destinatario == 'self'">
              La misma persona que lo generó
            </span>
            <span v-else>
              Otra persona ({{ datosComprobante.formulario.cuitCuilDestinatario | cuit }})
            </span>
          </div>
          <div v-if="datosComprobante.formulario.observaciones">
            <span class="font-medium">Observaciones: </span>
            <span>{{ datosComprobante.formulario.observaciones }}</span>
          </div>
          <div v-if="datosComprobante.formulario.usoJudicial">
            <div>
              <span class="font-medium">Radicación: </span>
              <span>{{ datosComprobante.formulario.datosJudiciales.radicacion.descripcion }}</span>
            </div>
            <div>
              <span class="font-medium">Número de radicación: </span>
              <span v-if="datosComprobante.formulario.datosJudiciales.numeroRadicacion">
                {{ datosComprobante.formulario.datosJudiciales.numeroRadicacion }}
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <span class="font-medium">Fuero: </span>
              <span>{{ datosComprobante.formulario.datosJudiciales.fuero.descripcion }}</span>
            </div>
            <div>
              <span class="font-medium">Partido: </span>
              <span v-if="datosComprobante.formulario.datosJudiciales.partido">
                {{ datosComprobante.formulario.datosJudiciales.partido.descripcion }}
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <span class="font-medium">Causa nro.: </span>
              <span>{{ datosComprobante.formulario.datosJudiciales.causaNumero }}</span>
            </div>
            <div>
              <span class="font-medium">Autos: </span>
              <span v-if="datosComprobante.formulario.datosJudiciales.autos">{{
                datosComprobante.formulario.datosJudiciales.autos
              }}</span>
              <span v-else>-</span>
            </div>
          </div>
          <!-- Datos Comprobantes DPPJ -->
          <div v-if="datosComprobante.formulario.legajo">
            <span class="font-medium">Legajo: </span>
            <span>{{ datosComprobante.formulario.legajo }}</span>
          </div>
          <div v-if="datosComprobante.formulario.razonSocial">
            <span class="font-medium">Razón social: </span>
            <span>{{ datosComprobante.formulario.razonSocial }}</span>
          </div>
          <!-- Trámite se imprime más arriba (se podría discriminar por comprobante si se quiere manipular el orden en que se muestran) -->
          <!-- <div v-if="datosComprobante.formulario.tramite">
            <span class="font-medium">Trámite: </span>
            <span>{{ datosComprobante.formulario.tramite.descripcion }}</span>
          </div> -->
          <div v-if="datosComprobante.formulario.precio">
            <span class="font-medium">Precio: </span>
            <span>{{ datosComprobante.formulario.precio.descripcion }} -
              {{ datosComprobante.formulario.precio.precio | currency }}</span>
          </div>
          <div v-if="datosComprobante.formulario.rangoPrecio">
            <span class="font-medium">Precio: </span>
            <span>{{ datosComprobante.formulario.rangoPrecio.descripcion }}</span>
          </div>
          <div v-if="datosComprobante.formulario.delegacion">
            <span class="font-medium">Delegación: </span>
            <span>{{ datosComprobante.formulario.delegacion.nombre }}</span>
          </div>
          <!-- Datos Comprobante honorarios judiciales -->
          <div v-if="datosComprobante.formulario.nroEscritura">
            <span class="font-medium">Número de escritura: </span>
            <span>{{ datosComprobante.formulario.nroEscritura }}</span>
          </div>
          <div v-if="datosComprobante.formulario.anioEscritura">
            <span class="font-medium">Año de escritura: </span>
            <span>{{ datosComprobante.formulario.anioEscritura }}</span>
          </div>
          <div v-if="datosComprobante.formulario.radicacion">
            <span class="font-medium">Radicación: </span>
            <span>{{ datosComprobante.formulario.radicacion.descripcion }}</span>
          </div>
          <div v-if="datosComprobante.formulario.nroRadicacion">
            <span class="font-medium">Número de radicación: </span>
            <span>{{ datosComprobante.formulario.nroRadicacion }}</span>
          </div>
          <div v-if="datosComprobante.formulario.fuero">
            <span class="font-medium">Fuero: </span>
            <span>{{ datosComprobante.formulario.fuero.descripcion }}</span>
          </div>
          <div v-if="datosComprobante.formulario.partido">
            <span class="font-medium">Partido: </span>
            <span>{{ datosComprobante.formulario.partido.descripcion }}</span>
          </div>
          <div v-if="datosComprobante.formulario.departamentoJudicial">
            <span class="font-medium">Departamento judicial: </span>
            <span>{{ datosComprobante.formulario.departamentoJudicial.descripcion }}</span>
          </div>
          <div v-if="datosComprobante.formulario.honorarios">
            <span class="font-medium">Honorarios: </span>
            <span>{{ datosComprobante.formulario.honorarios | currency }}</span>
          </div>
          <div v-if="datosComprobante.formulario.tipoHonorario">
            <span class="font-medium">Tipo de honorario: </span>
            <span>{{ datosComprobante.formulario.tipoHonorario.descripcion }}</span>
          </div>
          <div v-if="datosComprobante.formulario.instanciaRegulacion">
            <span class="font-medium">Instancia de regulación: </span>
            <span>{{ datosComprobante.formulario.instanciaRegulacion.descripcion }}</span>
          </div>
          <div v-if="datosComprobante.formulario.caratulaCausante">
            <span class="font-medium">Acto/peticionante/causante: </span>
            <span>{{ datosComprobante.formulario.caratulaCausante }}</span>
          </div>
          <div v-if="datosComprobante.formulario.caratulaDemandado">
            <span class="font-medium">Demandado: </span>
            <span>{{ datosComprobante.formulario.caratulaDemandado }}</span>
          </div>
          <div v-if="datosComprobante.formulario.caratulaMateria">
            <span class="font-medium">Materia: </span>
            <span>{{ datosComprobante.formulario.caratulaMateria }}</span>
          </div>
        </div>
        <MessageCard v-if="['MBP', 'PNET'].includes(medioPago?.id.trim())" type="info" message=""
          class="divide-x divide-blue-200">
          <div class="space-y-1 pl-4">
            <p class="block text-justify">
              Para finalizar el proceso de pago, será redirigido al sitio de
              {{ medioPago?.id.trim() === 'MBP' ? 'Macro Pago' : 'Provincia NET' }}.
            </p>
            <p class="block text-justify">
              El estado del comprobante permanecerá EN PROCESO o PAGO A REGISTRAR hasta tanto
              recibamos la notificación de pago por parte de
              {{ medioPago?.id.trim() === 'MBP' ? 'Macro' : 'Provincia NET' }}
              y el mismo sea registrado.
            </p>
          </div>
        </MessageCard>

        <div class="space-y-1">
          <p class="text-base text-gray-900">
            ¿Desea confirmar los datos y generar el comprobante?
          </p>
          <p v-if="error" class="text-sm font-medium text-red-500">
            {{ error }}
          </p>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Cargando from '@/components/Core/Cargando.vue'
import MessageCard from '@/components/Core/MessageCard'
import { useService } from '@colescba/app-vue'
import { useSession } from '@colescba/ui'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  props: {
    medioPago: { type: Object, required: false },
    isOpen: { type: Boolean, required: true },
  },

  mixins: [useService('portalPagos'), useSession()],

  components: { Cargando, MessageCard },

  data() {
    return {
      loading: false,
      error: null,
    }
  },

  computed: {
    ...mapState({
      currentStep: state => state.stepper.currentStep,
      formulario: state => state.stepper.formulario,
    }),
    ...mapGetters({
      datosComprobante: 'stepper/datosComprobante',
    }),
  },

  watch: {
    isOpen(newValue, oldValue) {
      if (newValue) {
        document.querySelector('body').classList.add('overflow-y-hidden')
      } else {
        document.querySelector('body').classList.remove('overflow-y-hidden')
      }
    },
  },

  methods: {
    ...mapMutations({
      setStepData: 'stepper/setStepData',
      addRequestData: 'stepper/addRequestData',
    }),

    ...mapActions({
      altaDeuda: 'stepper/altaDeuda',
    }),

    async generarPago() {
      this.loading = true
      this.error = null

      try {
        this.addRequestData({
          medios_pago: this.medioPago ? [this.medioPago.id] : [],
        })
        this.setStepData({
          stepIndex: this.currentStep.index,
          stepData: this.medioPago,
        })

        const deudaId = await this.altaDeuda({
          cuitCuil: this.user.cuitCuil.numero,
          portalPagos: this.portalPagos,
        })

        const medio = this.medioPago.id.trim()

        if (medio === 'MBP') {
          const html = await this.portalPagos.getHtmlMacroClick(this.user.cuitCuil.numero, deudaId)
          const blob = new Blob([html], { type: 'text/html' })
          const url = URL.createObjectURL(blob)
          window.location.href = url
        } else if (medio === 'PNET') {
          const result = await this.portalPagos.createProvinciaNetPayment(
            this.user.cuitCuil.numero,
            deudaId,
          )

          const redirectUrl =
            typeof result === 'string' ? result : result?.redirectUrl || result?.url || null

          if (redirectUrl) {
            console.log('Redirigiendo a ProvinciaNet...', redirectUrl)
            window.open(redirectUrl, '_blank')
          } else {
            console.log('Respuesta de ProvinciaNet (sin URL):', result)
          }
        } else {
          console.log('Medio de pago no soportado:', medio)
        }

        this.$emit('modal:confirm')
      } catch (error) {
        console.error(error)
        this.error = 'Ocurrió un error al generar el comprobante.'
      } finally {
        this.loading = false
      }
    },

    onCancel() {
      this.error = null
      this.$emit('modal:cancel')
    },
  },

  beforeDestroy() {
    document.querySelector('body').classList.remove('overflow-y-hidden')
  },
}
</script>
